define([
	"dojo/_base/declare",
	"dojo/dom-construct",
	"csi",
	"csi/def",
	"csi/def/ActionFactory",
	"csi/def/Rule",
	"csi/util"
], function(declare,domConstruct,csi,def,ActionFactory,Rule,util) {

	return declare(null, {
		constructor: function(/*XMLNode?*/xn) {
			this.accessAction = util.getProperty(xn, "AccessAction");
			this.m_actions = util.getDefs(xn, "child::*", ActionFactory.newAction, true);
			this.m_rules = util.getDefs(xn, "Rule", Rule);
		},

		hasActions: function() {
			return this.m_actions && this.m_actions.length;
		},

		getActions: function() {
			return this.m_actions;
		},

		getActionsNum: function() {
			return  this.m_actions ? this.m_actions.length : 0;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			def.resolveDefs(this.m_actions, lr, rcRoot, nodeRoot);
		},

		addAction: function(/*Action*/action, /*Number?*/nIndex) {
			if (!this.m_actions)
				this.m_actions = [];

			if (nIndex != null) {
				this.m_actions.splice(nIndex, 0, action);
			} else {
				this.m_actions.push(action);
			}

			return action;
		},

		getAction: function(id) {
			return csi.search(this.m_actions, function(a) { return a.m_id == id; } );
		},

		removeAction: function(id) {
			var	a = this.getAction(id);
			if (a) {
				this.m_actions.dele(a);
			}
		},

		toHtml: function(/*Context*/ctx, /*DOMNode*/refNode, /*Boolean*/bRenderDisabled, /*Boolean*/bForceDisabled) {
			if (!this.m_actions) {
				return null;
			}
			
			if (bForceDisabled && !bRenderDisabled) {
				return null;
			}
			
			var	div = domConstruct.create("div", {
				"class": "csiActions " + (this.m_class || "")
			}, refNode);

			var	b = false;

			for (var i = 0; i < this.m_actions.length; ++i) {
				if (this.m_actions[i].toHtml(ctx, div, bRenderDisabled, bForceDisabled)) {
					b = true;
				}
			}

			if (b) {
				return div;
			}

			// remove div if no actions rendered
			refNode.removeChild(div);
			return null;
		}
	});
});